<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:28:49
-->
<template>
  <div>
    <div class="top">
      <el-button  v-if="codeData.indexOf('142') != -1" @click="addAdminFn" type="primary"
        >添加站点</el-button
      >
      <div class="search">
        <a-select
          v-model:value="flagDisable"
          allowClear
          style="width: 418px; margin-right: 20px"
          placeholder="按站点状态筛选"
        >
          <a-select-option value="0">启用</a-select-option>
          <a-select-option value="1">停用</a-select-option>
        </a-select>
        <a-input
          style="width: 170px; margin-right: 20px"
          v-model:value="value"
          placeholder="站点名称"
        />
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <multistageTable
        @move="move"
        :tableData="tableData"
        @addAdminFn="addAdminFn"
        @editAdmin="editAdmin"
      />
    </a-spin>
    <addSite @closeTwo="closeTwo"  :tableData="tableData" :item="item" @close="close" :visible="visible"></addSite>
  </div>
</template>

<script>
import addSite from "./add_site.vue";
import multistageTable from "./multistage_table.vue";
import { tree } from "./station_group_management";
export default {
  data() {
    return {
      height: 0,
      visible: false,
      value: "",
      flagDisable: undefined,
      tableData: [],
      item: {},
      loading: false,
      codeData:[],
    };
  },
  components: {
    multistageTable,
    addSite,
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 419;
    window.onresize = () => {
        return (() => {
          this.height = document.documentElement.clientHeight - 419;
        })();
      };
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    search() {
      this.getList();
    },
    getList() {
      this.loading = true;
      tree({
        flagDisable: this.flagDisable,
        name: this.value,
      }).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.tableData = res.data;
        }
      });
    },
    // 切换 搜索
    selectFn(value) {
      this.selectValue = value;
    },
    onShowSizeChange(current) {
      console.log(current, "分页页面回来了");
    },
    handleTableChange(pag, filters, sorter) {
      console.log(pag, filters, sorter);
    },
    addAdminFn() {
        this.item = {}
        this.visible = true;
    },
    close() {
      this.visible = false;
      this.getList();
    },
    closeTwo(){
      this.visible = false;
    },
    move() {
      this.getList();
    },
    editAdmin(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    open() {
      this.$prompt(
        '站点删除是不可逆的操作，若确需删除，请在下方输入框中输入站点名称后在点击"确认删除"按钮',
        "确认删除站点",
        {
          confirmButtonText: "确认删除1",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入确需删除的站点名称",
          customClass: "deletBox",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(({ value }) => {
          console.log(value, "sssssssssss");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 450px;
  }
  /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.deletBox {
  background: red !important;
  .el-message-box__message {
    color: #ccc !important;
  }
}
.el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>